<template>
  <el-dialog
    title="电子数据存证证书"
    class="com-dialog g-certi-dialog"
    :visible.sync="dialogVisible"
    :before-close="close"
    width="980px"
  >
    <div class="g-certi-dialog-conent">
      <!--        <img :src="globalConfig.domain.junziqianApi + '/yaic/showCerti?presId=20030328'">-->
      <div class="img-certi">
        <a
          v-loading="certLoading"
          :href="certUrl"
          target="_blank"
          title="点击放大"
          v-if="certUrl"
          class="img-certi-a"
        >
          <img
            :src="certUrl"
            @loadstart="certLoading = true"
            @load="certLoading = false"
            class="img-certi-img"
          />
        </a>
        <a
          href="javascript:void(0);"
          @click="flushCertStatus()"
          title="点击刷新"
          v-else
          v-loading="certLoading"
          style="min-height: 637px; display: inline-block"
        >
          <img
            :src="certUrl"
            @loadstart="certLoading = true"
            @load="certLoading = false"
          />
        </a>
      </div>
      <div class="right-btn-warp">
        <el-button
          id="tag-copy"
          :data-clipboard-text="leftPad(param.preservationId, 10, '0')"
          @click="copyText($event)"
          size="small"
          class="g-certi-btn"
          >复制备案号</el-button
        >
        <el-button
          id="tag-copy1"
          :data-clipboard-text="param.preservationId"
          @click="copyTextToQuery($event)"
          size="small"
          class="g-certi-btn"
          >复制备案号并查询
        </el-button>
        <el-button
          size="small"
          @click="downloadCert(1, param.preservationId)"
          class="g-certi-btn"
          >下载图片证书</el-button
        >
        <el-button
          size="small"
          @click="downloadCert(2, param.preservationId)"
          class="g-certi-btn"
          >下载PDF证书</el-button
        >
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="close">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

import globalConfig from "../../assets/js/config/global";
import Clipboard from "clipboard";
import { configUrl, yaicExport, yaicDownLoadImg, ApiMethods, } from "../../assets/js/http-serve/http-methods";
import { isInDingTalk } from '@/assets/js/utils/ding-env';

export default {
  props: {
    param: {
      type: Object
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },

  },
  data () {
    return {
      certLoading: true,
      certStatus: '',
      certUrl: null
    };
  },
  created () {
    this.initCerti();
  },
  methods: {
    flushCertStatus: function () {
      let _param = this.param;
      ApiMethods.CertiController.certiStatus(_param).then(result => {
        this.certStatus = result.success && result.data;
        if (result.success && !result.data) {
          this.$confirm('证书努力生成中，请稍候再试', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }).then(() => {
          }).catch(() => {
          });
        } else if (result.success && result.data) {
          // location.reload();
        }

      })
    },
    downloadCert (type) {
      yaicDownLoadImg({
        presId: this.param.preservationId,
        downType: type
      }).then(data => {
      }).catch(err => {
      });
    },

    initCerti () {

      this.certUrl = globalConfig.domain.junziqianApi + '/yaic/showCerti?presId=' + this.param.preservationId;

    },
    close () {
      this.$emit("setCSDialogData", {
        cSDialogVisible: false,
        cSDialogData: {}
      });
    },
    // 复制
    copyText () {
      const clipboard = new Clipboard("#tag-copy")

      clipboard.on('success', e => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          type: 'waning',
          message: '该浏览器不支持自动复制'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    // 复制
    copyTextToQuery () {
      const clipboard = new Clipboard("#tag-copy1")
      clipboard.on('success', e => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          type: 'waning',
          message: '该浏览器不支持自动复制'
        })
        // 释放内存
        clipboard.destroy()
      })
      setTimeout(() => {
        let newWindow = '';
        if (!isInDingTalk) newWindow = window.open();
        let presId = this.leftPad(this.param.presId, 10, '0')
        let href = `${globalConfig.domain.junziqianWebOp}/blockChain?presId=` + presId
        isInDingTalk ? location.href = href : newWindow.location.href = href
      }, 1000)
    },
    leftPad (value, size, str) { // {{ v.num|leftPad(10, '0')}}
      if (value == null || value === undefined) {
        return value
      }
      var result = '' + value
      if (size <= result.length) {
        return result
      }
      var pad = (typeof str === 'string' && str.length === 1) ? str : '0'
      for (var idx = result.length; idx < size; idx++) {
        result = pad + result
      }
      return result
    }
  },
};
</script>

<style lang="less" >
.g-certi-dialog .el-dialog__footer {
  -webkit-box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.17);
  padding: 10px 15px;
}

.g-certi-dialog-conent {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 80px 15px 205px;
  display: flex;

  .img-certi {
    box-sizing: border-box;
    min-height: 636px;
    flex: 1;
    padding-right: 40px;
  }

  .img-certi-img,
  .img-certi-a {
    width: 100%;
    height: 100%;
  }

  .right-btn-warp {
    flex: 0 0 175px;
    padding-top: 26px;
  }

  .g-certi-btn {
    width: 100%;
    height: 35px;
    display: block;
    margin-bottom: 15px;
    margin-left: 0;

    &:hover {
      background-color: #fff;
      color: rgba(236, 28, 28, 1);
      border-color: rgba(236, 28, 28, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/apply-list/certiServiceDialog2.vue